module.exports = __webpack_public_path__ + "img/pre_20211001_15pll.1be6df09.png";